import { Link } from 'react-router-dom';
import { Search, Wand2, Settings } from '@/lib/icons';
import { BrandGlyph } from './BrandGlyph';
import { SaveStateIndicator } from './SaveStateIndicator';
import { Button } from '@/components/ui/button';
import { useSaveState } from '@/stores/selectors';

/** ⌘K 팔레트 열기 — CommandPalette(M5)가 이 이벤트를 구독한다. */
export function openCommandPalette() {
  window.dispatchEvent(new CustomEvent('codex:palette'));
}

export function TopBar() {
  const saveState = useSaveState();
  return (
    <header
      className="sticky top-0 z-topbar flex flex-wrap items-center justify-between gap-2 border-b border-line px-3 py-2 backdrop-blur-xl md:flex-nowrap md:gap-4 md:px-[22px] md:py-[14px]"
      style={{ background: 'rgba(8,10,18,.82)' }}
    >
      <Link to="/" className="flex flex-none items-center gap-[14px]">
        <BrandGlyph />
        <div>
          <h1 className="font-mono text-sm font-semibold uppercase tracking-[0.24em] text-ink md:tracking-[0.32em]">
            Loom
          </h1>
          <p className="text-xs leading-none text-faint">별을 죽인 자들</p>
        </div>
      </Link>

      <button
        type="button"
        onClick={openCommandPalette}
        className="group order-last flex h-9 w-full flex-none items-center gap-2 rounded-md border border-line-2 bg-panel px-3 text-left text-sm text-faint transition hover:border-star hover:text-dim md:order-none md:max-w-md md:flex-1"
      >
        <Search className="size-4" />
        <span>검색 · 이동 · 생성</span>
        <kbd className="ml-auto rounded border border-line-2 bg-bg-2 px-1.5 py-0.5 font-mono text-[10px] tracking-wide text-faint">
          ⌘K
        </kbd>
      </button>

      <div className="flex flex-none items-center gap-[10px]">
        <SaveStateIndicator mode={saveState} />
        <Button asChild variant="mono" size="sm" title="커널 홈 — 에이전트에게 지시 (수동 화면에선 ⌘J 도크)">
          <Link to="/">
            <Wand2 className="size-4" />
            <span className="hidden sm:inline">커널</span>
            <kbd className="ml-1 hidden rounded border border-line-2 bg-bg-2 px-1 font-mono text-[9px] text-faint sm:inline">⌘J</kbd>
          </Link>
        </Button>
        <Button asChild variant="outline" size="icon" title="설정">
          <Link to="/settings" aria-label="설정">
            <Settings />
          </Link>
        </Button>
      </div>
    </header>
  );
}
